<template>
  <div class="game-page" :style="pageStyle">
    <van-nav-bar
      class="game-nav"
      title=""
      left-arrow
      @click-left="$router.back()"
    />
    <div class="game-frame-wrap" v-if="url">
      <iframe
        class="game-frame"
        ref="iframe"
        scrolling="auto"
        frameborder="0"
        id="iframe"
        allow="fullscreen"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: 'gamePage',
  data() {
    return {
      url: null,
      viewportHeight: typeof window !== 'undefined' ? window.innerHeight : 667,
    };
  },
  computed: {
    pageStyle() {
      return {
        height: `${this.viewportHeight}px`,
      };
    },
  },
  created() {
    let that = this;
    var query = that.$route.query;
    // 打开代理
    console.log(query)
    if (query.dailiD == 1) {
      that.getAgentLoginUrl();
      return;
    }
    // 打开客服
    if (query.dailiD == 2) {
      that.getservicerurl();
      return;
    }
    if (query.app == 1) {
      that.url = that.$store.state.appInfo.ios_download_url;
      return;
    }
    if (query.name) {
      that.goGamePage(query.name, query.type, query.code);
    }
  },
  methods: {
    updateViewportHeight() {
      const visualViewport = window.visualViewport;
      this.viewportHeight = visualViewport ? visualViewport.height : window.innerHeight;
    },
    bindViewportEvents() {
      this.updateViewportHeight();
      window.addEventListener('resize', this.updateViewportHeight);
      window.addEventListener('orientationchange', this.updateViewportHeight);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', this.updateViewportHeight);
        window.visualViewport.addEventListener('scroll', this.updateViewportHeight);
      }
    },
    unbindViewportEvents() {
      window.removeEventListener('resize', this.updateViewportHeight);
      window.removeEventListener('orientationchange', this.updateViewportHeight);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', this.updateViewportHeight);
        window.visualViewport.removeEventListener('scroll', this.updateViewportHeight);
      }
    },
    // 打开客服
    getservicerurl() {
      let that = this;
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
    // 打开代理
    getAgentLoginUrl() {
      let that = this;
      that.$apiFun.get('/api/getAgentLoginUrl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
    // 打开游戏
    goGamePage(name, type, code) {
      let that = this;
      that.$apiFun
        .post('/api/getGameUrl', { plat_name: name, game_type: type || 0, game_code: code, is_mobile_url: 1 })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.url = res.data.url;
          }
        })
        .catch(res => { });
    },
  },
  mounted() {
    this.bindViewportEvents();
    document.body.classList.add('game-page-open');
  },
  updated() {
    let that = this;
    if (that.url && that.$refs.iframe) {
      that.$refs.iframe.contentWindow.location.replace(that.url);
    }
  },
  beforeDestroy() {
    this.unbindViewportEvents();
    document.body.classList.remove('game-page-open');
  },
};
</script>

<style lang="scss" scoped>
.game-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #000;
  box-sizing: border-box;
}

.game-nav {
  flex-shrink: 0;
  background-color: #ede9e7;
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
}

.game-frame-wrap {
  flex: 1;
  min-height: 0;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

.game-frame {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
  background: #000;
}
</style>
